import script from "./BaseCheckBox.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseCheckBox.vue?vue&type=script&setup=true&lang=js"

import "./BaseCheckBox.vue?vue&type=style&index=0&id=dcc9402c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dcc9402c"]])

export default __exports__